import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { BroadcastDevice } from '@magnetar/data-access'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export function useBroadcastDeviceById(deviceId: string | number | undefined) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<ApiResponse<BroadcastDevice>>(
    token && deviceId ? `/api/broadcast-device/${deviceId}` : null,
    undefined,
    token ?? '',
  )

  return {
    device: data?.data,
    isLoading,
    isError: error,
    mutate,
  }
}
